import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  forwardRef,
  Input,
  ViewChild,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { environment } from '@macs-frontend/env';
import { DropdownComponent } from '@macs-frontend/web-macs/shared';
import { DropdownOptionsSource } from '../dropdown/dropdown.component';

@Component({
  /* eslint-disable-next-line @angular-eslint/component-selector */
  selector: '[cmAddProjectTask]',
  templateUrl: 'add-project-task.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AddProjectTaskComponent),
      multi: true,
    },
  ],
})
export class AddProjectTaskComponent extends DropdownComponent {
  // @ts-expect-error
  @Input() link: string;
  // @ts-expect-error
  @Input() itemName: string;
  imagesPath = environment.images_path;

  // @ts-expect-error
  @ViewChild('input') inputElem: ElementRef<HTMLElement>;

  selectValue(option: any): void {
    this.valueChange.emit(option);
    this.model = '';
    this.inputElem.nativeElement.focus();
  }

  addNew(
    value?: string | DropdownOptionsSource | null,
    url?: string | DropdownOptionsSource[] | null,
    itemName?: string | null,
  ) {
    super.addNew(value as string, url as string, itemName as string);
  }

  async loadChosenOption() {
    if (this.chosenOption) {
      await super.loadChosenOption();
    }
  }
}
